module.exports = __webpack_public_path__ + "static/media/Artboard5.ce4ad025.png";